module.exports = __webpack_public_path__ + "static/Yuii.99784894.png";